import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { QueryService } from '../comun/services/query.service';
import { GlobalConstants } from '../global-constants';

@Component({
  selector: 'app-quizas-conozcas',
  templateUrl: './quizas-conozcas.component.html',
  styleUrls: ['./quizas-conozcas.component.css']
})
export class QuizasConozcasComponent implements OnInit {
  misdatos: any = null;
  perfiles: any[] = [];
  busy = true;
  error = '';
  global: any = GlobalConstants;
  get ubicacionBusqueda(): string {
    return [this.misdatos?.barrio, this.misdatos?.ciudad]
      .filter((valor: any) => typeof valor === 'string' && !!valor.trim()).join(' · ');
  }
  readonly skeletons = [1, 2, 3];
  @ViewChild('carrusel') carrusel?: ElementRef<HTMLDivElement>;
  paginaActual = 0;
  tarjetasPorPagina = 3;

  get totalPaginas(): number {
    return Math.ceil(this.perfiles.length / this.tarjetasPorPagina);
  }

  get paginas(): number[] {
    return Array.from({ length: this.totalPaginas }, (_, index) => index);
  }

  @HostListener('window:resize')
  actualizarColumnas(): void {
    const ancho = window.innerWidth;
    this.tarjetasPorPagina = ancho < 640 ? 1 : ancho < 1050 ? 2 : 3;
    this.paginaActual = Math.min(this.paginaActual, Math.max(0, this.totalPaginas - 1));
  }

  irPagina(indice: number): void {
    const elemento = this.carrusel?.nativeElement;
    if (!elemento || !this.totalPaginas) return;
    const pagina = Math.max(0, Math.min(this.totalPaginas - 1, indice));
    const primera = elemento.querySelector<HTMLElement>('.iguau-sugerencias__card');
    if (!primera) return;
    const gap = parseFloat(getComputedStyle(elemento).columnGap) || 0;
    const anchoTarjeta = primera.getBoundingClientRect().width;
    elemento.scrollTo({ left: pagina * this.tarjetasPorPagina * (anchoTarjeta + gap), behavior: 'smooth' });
    this.paginaActual = pagina;
  }

  cambiarPagina(direccion: number): void {
    this.irPagina(this.paginaActual + direccion);
  }

  sincronizarScroll(): void {
    const elemento = this.carrusel?.nativeElement;
    if (!elemento || !this.totalPaginas) return;
    const primera = elemento.querySelector<HTMLElement>('.iguau-sugerencias__card');
    if (!primera) return;
    const gap = parseFloat(getComputedStyle(elemento).columnGap) || 0;
    const paso = (primera.getBoundingClientRect().width + gap) * this.tarjetasPorPagina;
    if (paso > 0) this.paginaActual = Math.max(0, Math.min(this.totalPaginas - 1, Math.round(elemento.scrollLeft / paso)));
  }

  constructor(private query: QueryService) {}

  ngOnInit(): void {
    this.actualizarColumnas();
    this.getMisDatos();
  }

  getMisDatos(): void {
    this.busy = true;
    this.error = '';
    this.query.query('misdatos', 'GET', null).subscribe({
      next: (resultado: any) => {
        // El servicio original devuelve los datos del usuario directamente.
        this.misdatos = resultado?.registros && !Array.isArray(resultado.registros)
          ? resultado.registros : resultado;
        // También muestra sugerencias públicas cuando no existe sesión.
        this.getQuizasConozcas();
      },
      error: () => {
        // Para invitados, misdatos puede fallar con 401: continuamos como visitantes.
        this.misdatos = null;
        this.getQuizasConozcas();
      }
    });
  }

  getQuizasConozcas(): void {
    this.busy = true;
    this.error = '';
    this.query.query('perfiles', 'QUIZASCONOZCAS', null).subscribe({
      next: (resultado: any) => {
        if (resultado && resultado.resultado === 'OK' && Array.isArray(resultado.registros)) {
          this.perfiles = resultado.registros.filter((p: any) => !!p && !!p.slug);
        } else {
          this.perfiles = [];
          this.error = resultado?.mensaje || 'No hemos podido cargar las sugerencias.';
        }
        this.paginaActual = 0;
        this.busy = false;
      },
      error: () => {
        this.perfiles = [];
        this.busy = false;
        this.error = 'No se han podido cargar los perfiles sugeridos.';
      }
    });
  }

  recargar(): void {
    this.getQuizasConozcas();
  }

  perfilUrl(perfil: any): string {
    const base = String(GlobalConstants.urlServer || '/').replace(/\/?$/, '/');
    return base + 'perfil/' + encodeURIComponent(perfil?.slug || '') + '/';
  }

  imagenMascota(perfil: any): string {
    return perfil?.mascota?.foto_principal_thumb || perfil?.foto_principal_thumb || '';
  }

  imagenPerfil(perfil: any): string {
    return perfil?.foto_principal_thumb || '';
  }

  nombreMascota(perfil: any): string {
    return perfil?.mascota?.ma_nombre || 'Su mascota';
  }

  nombrePersona(perfil: any): string {
    return perfil?.first_name || 'Miembro de iGuau';
  }

  ubicacion(perfil: any): string {
    return [perfil?.barrio, perfil?.ciudad].filter((valor: any) => !!valor).join(' · ');
  }

  trackByPerfil(index: number, perfil: any): number | string {
    return perfil?.ID || perfil?.ma_us_id || perfil?.slug || index;
  }
}
